const optionBuilder = (_originalSelect, _customSelect, _value, _text) => {
    let tempOption = document.createElement("div")
    tempOption.classList.add("customSelect-option")
    tempOption.setAttribute("selectOptionTag", _value)
    tempOption.innerText = _text
    tempOption.addEventListener("click", (e) => {
        _originalSelect.value = e.target.getAttribute("selectOptionTag")
        _customSelect.textContent = e.target.textContent
        _originalSelect.dispatchEvent(new Event("change"))
    })

    return tempOption
}

let allCustomSelectElements = []
    let selectElementList
    selectElementList = document.querySelectorAll('select')

    if(selectElementList.length == 0) return

    selectElementList.forEach(function(selectElement) {
        let selectOptions = null
        let customSelectWrapper = null
        let customSelectElement = null
        let customSelectOptionsElement = null
        selectElement.style.display = "none"
        selectOptions = selectElement.querySelectorAll('option')

        customSelectWrapper = document.createElement('div')
        customSelectWrapper.classList.add('customSelect-wrapper')
        customSelectElement = document.createElement('div')

        if(selectOptions.length > 0)
            customSelectElement.innerText = selectOptions[0].textContent

        customSelectElement.classList.add('customSelect')

        customSelectElement.addEventListener('click', function(e) {
            e.stopPropagation()
            customSelectElement.classList.toggle('customSelect-active')
            customSelectWrapper.classList.toggle('active')
            closeAllSelect(customSelectWrapper)
        })

        customSelectOptionsElement = document.createElement('div')
        customSelectOptionsElement.classList.add('customSelect-options')

        selectOptions.forEach(function(selectOption) {
            let tempOption = optionBuilder(selectElement, customSelectElement, selectOption.value, selectOption.innerText)
            customSelectOptionsElement.appendChild(tempOption)
        })

        customSelectWrapper.appendChild(customSelectElement)
        customSelectWrapper.appendChild(customSelectOptionsElement)
        selectElement.parentNode.insertBefore(customSelectWrapper, selectElement.nextSibling)
        allCustomSelectElements.push(customSelectWrapper)
    })



const closeAllSelect = (_clicked = null) => {
    allCustomSelectElements.forEach((customSelectElement) => {
        if(_clicked == customSelectElement) return
        customSelectElement.classList.remove('active')
        customSelectElement.querySelector('.customSelect').classList.remove('customSelect-active')
    })
}

document.addEventListener("click", closeAllSelect);
